import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./topbar.scss";

export default function Topbar({menuOpen, setMenuOpen}) {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    // Hamburger commented out – will redo later
    // <div className={"topbar " + (menuOpen && "active")}>
    <div className="topbar">
      <div className="wrapper">
        <div className="left">
          <Link to="/" className="logo">
            LW
          </Link>
          <nav className="topbar__nav">
            {isHomePage ? (
              <>
                <a href="#intro" className="topbar__navLink">Home</a>
                <a href="#about" className="topbar__navLink">About</a>
                <a href="#skills" className="topbar__navLink">Skills</a>
                <a href="#works" className="topbar__navLink">Works</a>
                <Link to="/my-portfolio" className="topbar__navLink">My Portfolio</Link>
                <a href="#contact" className="topbar__navLink">Contact</a>
              </>
            ) : (
              <>
                <Link to="/#intro" className="topbar__navLink">Home</Link>
                <Link to="/#about" className="topbar__navLink">About</Link>
                <Link to="/#skills" className="topbar__navLink">Skills</Link>
                <Link to="/#works" className="topbar__navLink">Works</Link>
                <Link to="/my-portfolio" className="topbar__navLink">My Portfolio</Link>
                <Link to="/#contact" className="topbar__navLink">Contact</Link>
              </>
            )}
          </nav>
        </div>
        {/* Hamburger commented out – will redo later
        <div className="right">
          <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
        */}
      </div>
    </div>
  );
}
